import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { TransientProps } from '@common/types';

type OpenProps = TransientProps<{ open: boolean }>;

export const Container = styled.div`
  position: relative;
`;

export const Trigger = styled.button<OpenProps>`
  ${({ theme, $open: isOpen }) => css`
    width: 2.25rem;
    height: 2.25rem;
    border-radius: 0.5rem;
    border: 1px solid
      ${isOpen ? theme.colors.brand.primary.default : 'rgba(0, 0, 0, 0.18)'};
    background: ${isOpen
      ? theme.colors.brand.primary.opaque
      : theme.colors.background[100]};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${isOpen
      ? theme.colors.brand.primary.default
      : theme.colors.foreground[40]};
    transition: all 150ms ease;
    position: relative;
    padding: 0;

    &:hover {
      border-color: ${theme.colors.brand.primary.default};
      color: ${theme.colors.brand.primary.default};
    }

    > svg {
      width: 1rem;
      height: 1rem;
    }
  `}
`;

export const CurrentFlag = styled.span`
  ${({ theme }) => css`
    position: absolute;
    bottom: -3px;
    right: -3px;
    background: ${theme.colors.background[100]};
    border-radius: 2px;
    padding: 1px;
    border: 1px solid ${theme.colors.background[40]};
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
  `}
`;

export const Dropdown = styled(motion.div)`
  ${({ theme }) => css`
    position: absolute;
    top: calc(100% + 0.375rem);
    right: 0;
    background: ${theme.colors.background[100]};
    border: 1px solid ${theme.colors.background[40]};
    border-radius: ${theme.radii.md};
    box-shadow: 0 8px 24px rgba(27, 42, 74, 0.1);
    padding: 0.25rem;
    min-width: 12rem;
    z-index: 100;
  `}
`;

type OptionProps = TransientProps<{ active: boolean }>;

export const Option = styled.button<OptionProps>`
  ${({ theme, $active: isActive }) => css`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 0.625rem;
    border-radius: ${theme.radii.default};
    cursor: pointer;
    border: none;
    background: ${isActive ? theme.colors.brand.primary.opaque : 'none'};
    width: 100%;
    font-family: inherit;
    font-size: 0.78125rem;
    font-weight: ${isActive ? 600 : 400};
    color: ${isActive
      ? theme.colors.brand.primary.default
      : theme.colors.foreground[80]};
    text-align: left;
    transition: background 100ms ease;

    &:hover {
      background: ${isActive
        ? theme.colors.brand.primary.opaque
        : theme.colors.background[60]};
    }
  `}
`;

export const OptionCode = styled.span<OptionProps>`
  ${({ theme, $active: isActive }) => css`
    font-size: 0.625rem;
    font-weight: 600;
    color: ${isActive
      ? theme.colors.brand.primary.default
      : theme.colors.foreground[40]};
    margin-left: auto;
    text-transform: uppercase;
    opacity: ${isActive ? 0.5 : 1};
  `}
`;
